import React, { Component } from 'react'
import {
  TestimonialDescriptionImageItemContainer,
  TestimonialContainer,
  TestimonialDescriptionContainer,
  TestimonialDescription,
  TestimonialName,
  CountryName
} from './styledComponents'

class TestimonialDescriptionImageItem extends Component<Props> {
  render() {
    const {
      testimonialDescription,
      testimonialName,
      style,
      className,
      id,
      country
    } = this.props
    return (
      <TestimonialDescriptionImageItemContainer
        className={className}
        id={id}
        style={style}
      >
        <TestimonialContainer>
          <TestimonialDescriptionContainer>
            <TestimonialDescription
              dangerouslySetInnerHTML={{
                __html: testimonialDescription
              }}
            />
            <TestimonialName>{testimonialName}</TestimonialName>
            <CountryName>{country}</CountryName>
          </TestimonialDescriptionContainer>
        </TestimonialContainer>
      </TestimonialDescriptionImageItemContainer>
    )
  }
}

export default TestimonialDescriptionImageItem



// WEBPACK FOOTER //
// ./src/components/ExperimentalMarketing/IbCricketAtIpl2019/TestimonialSlick/TestimonialDescriptionImageItem/index.js